import { render, staticRenderFns } from "./WebPlayer.vue?vue&type=template&id=7f962412&scoped=true&"
import script from "./WebPlayer.vue?vue&type=script&lang=js&"
export * from "./WebPlayer.vue?vue&type=script&lang=js&"
import style0 from "./WebPlayer.vue?vue&type=style&index=0&id=7f962412&scoped=true&lang=css&"
import style1 from "./WebPlayer.vue?vue&type=style&index=1&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7f962412",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VBtn } from 'vuetify/lib/components/VBtn';
import { VCol } from 'vuetify/lib/components/VGrid';
import { VContainer } from 'vuetify/lib/components/VGrid';
import { VFadeTransition } from 'vuetify/lib/components/transitions';
import { VImg } from 'vuetify/lib/components/VImg';
import { VRow } from 'vuetify/lib/components/VGrid';
installComponents(component, {VBtn,VCol,VContainer,VFadeTransition,VImg,VRow})
